import { useEffect, useState } from 'react';
import Navigation from '../product/components/Navigation';
import Footer from '../product/components/Footer';

export default function ProductWakasa2() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const products = [
    {
      id: 1,
      mainImage: 'https://www.1994real.com/item/img/onko_wakasa2_01_i.png',
      images: [
        'https://www.1994real.com/item/img/onko_wakasa2_01-1.png',
        'https://www.1994real.com/item/img/onko_wakasa2_01-2.png',
        'https://www.1994real.com/item/img/onko_wakasa2_01-3.png'
      ],
      name: '01 X10−1756 マット'
    },
    {
      id: 2,
      mainImage: 'https://www.1994real.com/item/img/onko_wakasa2_02_i.png',
      images: [
        'https://www.1994real.com/item/img/onko_wakasa2_02-1.png',
        'https://www.1994real.com/item/img/onko_wakasa2_02-2.png',
        'https://www.1994real.com/item/img/onko_wakasa2_02-3.png'
      ],
      name: '02 A87048T マット'
    },
    {
      id: 3,
      mainImage: 'https://www.1994real.com/item/img/onko_wakasa2_03_i.png',
      images: [
        'https://www.1994real.com/item/img/onko_wakasa2_03-1.png',
        'https://www.1994real.com/item/img/onko_wakasa2_03-2.png',
        'https://www.1994real.com/item/img/onko_wakasa2_03-3.png'
      ],
      name: '03 L3105'
    },
    {
      id: 4,
      mainImage: 'https://www.1994real.com/item/img/onko_wakasa2_04_i.png',
      images: [
        'https://www.1994real.com/item/img/onko_wakasa2_04-1.png',
        'https://www.1994real.com/item/img/onko_wakasa2_04-2.png',
        'https://www.1994real.com/item/img/onko_wakasa2_04-3.png'
      ],
      name: '04 A87047T'
    },
    {
      id: 5,
      mainImage: 'https://www.1994real.com/item/img/onko_wakasa2_05_i.png',
      images: [
        'https://www.1994real.com/item/img/onko_wakasa2_05-1.png',
        'https://www.1994real.com/item/img/onko_wakasa2_05-2.png',
        'https://www.1994real.com/item/img/onko_wakasa2_05-3.png'
      ],
      name: '05 R72-158L'
    },
    {
      id: 6,
      mainImage: 'https://www.1994real.com/item/img/onko_wakasa2_06_i.png',
      images: [
        'https://www.1994real.com/item/img/onko_wakasa2_06-1.png',
        'https://www.1994real.com/item/img/onko_wakasa2_06-2.png',
        'https://www.1994real.com/item/img/onko_wakasa2_06-3.png'
      ],
      name: '06 M58-108 マット'
    }
  ];

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Navigation scrolled={scrolled} />
      
      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
          {/* Breadcrumb */}
          <div className="mb-8">
            <nav className="flex items-center space-x-2 text-sm text-gray-600">
              <a href="/" className="hover:text-gray-900 transition-colors cursor-pointer">
                トップページ
              </a>
              <span>&gt;</span>
              <a href="https://www.1994real.com/catalog.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors cursor-pointer">
                カタログ
              </a>
              <span>&gt;</span>
              <span className="text-gray-900">温故知新 若狭 弐 全6色 6(colors)</span>
            </nav>
          </div>

          {/* Product Header */}
          <div className="mb-12">
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
              <div>
                <h1 className="font-['Noto_Serif_JP'] text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                  温故知新 若狭 弐 全6色 6(colors)
                </h1>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 lg:min-w-[300px]">
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-3 pr-4 font-medium text-gray-700">frame</th>
                      <td className="py-3 text-gray-900">47□22-143</td>
                    </tr>
                    <tr>
                      <th className="text-left py-3 pr-4 font-medium text-gray-700">希望小売価格</th>
                      <td className="py-3 text-gray-900 font-bold">124,300円(税込)</td>
                    </tr>
                  </tbody>
                </table>
                <p className="text-xs text-gray-600 mt-4">
                  写真をクリックすると拡大してご覧になれます<br />
                  詳細は<a href="https://ameblo.jp/real-inouefumihide/" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline hover:text-gray-600 cursor-pointer">ブログ</a>にて紹介しています
                </p>
              </div>
            </div>
          </div>

          {/* Product Gallery */}
          <div className="space-y-16">
            {products.map((product) => (
              <div key={product.id} className="border-b border-gray-200 pb-16 last:border-b-0">
                {/* Main Image */}
                <div className="mb-6">
                  <div className="w-full h-[420px] bg-black rounded-lg overflow-hidden">
                    <img
                      src={product.mainImage}
                      alt={product.name}
                      className="w-full h-full object-contain cursor-pointer hover:opacity-90 transition-opacity"
                      onClick={() => window.open(product.mainImage, '_blank')}
                    />
                  </div>
                </div>

                {/* Thumbnail Images */}
                <div className="grid grid-cols-3 gap-4">
                  {product.images.map((image, index) => (
                    <div key={index} className="text-center">
                      <div className="w-full h-[130px] bg-gray-100 rounded-lg overflow-hidden mb-2">
                        <img
                          src={image}
                          alt={`${product.name} - ${index + 1}`}
                          className="w-full h-full object-contain cursor-pointer hover:opacity-80 transition-opacity"
                          onClick={() => window.open(image, '_blank')}
                        />
                      </div>
                      <p className="text-sm text-gray-700">{product.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Back to Catalog Button */}
          <div className="mt-12 text-center">
            <a
              href="https://real1994.official.ec/categories/4659620"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gray-900 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              ONLINE STORE
            </a>
          </div>
        </div>

        {/* Page Top Button */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors shadow-lg cursor-pointer z-40"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      </main>

      <Footer />
    </div>
  );
}
